import Constants from "~/helpers/enums/Constants";
import packagesServices from "~/services/packagesServices";

const findPackagesForService = (serviceId, packages) => {
	return packages.filter((pkg) => {
		const hasService = pkg.service && pkg.service.id === serviceId;
		return hasService;
	});
};

// Função para encontrar pacotes recomendados
const findRecommendedPackages = (selectedServices, availablePackages) => {
	const recommended = [];

	selectedServices.forEach((service) => {
		const packagesWithService = findPackagesForService(service.id, availablePackages);

		packagesWithService.forEach((pkg) => {
			recommended.push({
				...pkg,
				servicesIncluded: pkg.service ? [pkg.service] : [],
				servicesNotIncluded: [],
			});
		});
	});


	// Remover duplicatas e ordenar por economia
	const uniquePackages = recommended.filter((pkg, index, self) => index === self.findIndex((p) => p.id === pkg.id));

	const sortedPackages = uniquePackages.sort((a, b) => b.savings - a.savings);

	return sortedPackages;
};

// Action para definir serviços selecionados
const setSelectedServices = (services) => (dispatch) => {
	dispatch({
		type: Constants.SET_SELECTED_SERVICES,
		payload: { selectedServices: services },
	});
};

const loadAvailablePackages = (businessId, language) => (dispatch) => {
	dispatch({
		type: Constants.SET_LOADING_PACKAGE_OFFER,
		payload: { loading: true },
	});

	packagesServices
		.packagesList(businessId, language)
		.then(({ data }) => {
			dispatch({
				type: Constants.SET_AVAILABLE_PACKAGES,
				payload: { availablePackages: data || [] },
			});
		})
		.catch((error) => {
			console.error("❌ Erro ao carregar pacotes:", error);
			dispatch({
				type: Constants.SET_ERROR_PACKAGE_OFFER,
				payload: { error: error.message },
			});
		});
};

// Action para analisar serviços selecionados e encontrar pacotes
const analyzeSelectedServices = (services, availablePackages) => {
    return (dispatch) => {
        const recommended = findRecommendedPackages(services, availablePackages);
        dispatch({
            type: Constants.SET_RECOMMENDED_PACKAGES,
            payload: { recommendedPackages: recommended },
        });
    };
};

// Action para aceitar oferta de pacote
const acceptPackageOffer = (packageId, recommendedPackages) => (dispatch) => {
	const acceptedPackage = recommendedPackages.find((p) => p.id === packageId);
	if (acceptedPackage) {
		dispatch({
			type: Constants.ACCEPT_PACKAGE_OFFER,
			payload: { acceptedPackage },
		});
	}
};

// Action para recusar oferta de pacote
const declinePackageOffer = () => (dispatch) => {
	dispatch({
		type: Constants.DECLINE_PACKAGE_OFFER,
		payload: {},
	});
};

// Action para mostrar oferta de pacote
const showPackageOffer = () => (dispatch) => {
	dispatch({
		type: Constants.SET_SHOW_PACKAGE_OFFER,
		payload: { showPackageOffer: true },
	});
};

// Action para esconder oferta de pacote
const hidePackageOffer = () => (dispatch) => {
	dispatch({
		type: Constants.SET_SHOW_PACKAGE_OFFER,
		payload: { showPackageOffer: false },
	});
};

// Action para limpar ofertas
const clearPackageOffers = () => (dispatch) => {
	dispatch({
		type: Constants.CLEAR_PACKAGE_OFFERS,
		payload: {},
	});
};

export default {
	setSelectedServices,
	loadAvailablePackages,
	analyzeSelectedServices,
	acceptPackageOffer,
	declinePackageOffer,
	showPackageOffer,
	hidePackageOffer,
	clearPackageOffers,
};
